/**
 * Tag Suggestions Constants
 *
 * Constants for tag suggestion functionality including debounce timing
 * and result limits.
 */

/** Debounce delay in milliseconds for tag suggestion search */
export const TAG_SUGGESTIONS_DEBOUNCE_MS = 300;

/** Default maximum number of tag suggestions to return */
export const TAG_SUGGESTIONS_DEFAULT_LIMIT = 5;

/** Minimum query length before triggering API search */
export const TAG_SUGGESTIONS_MIN_QUERY_LENGTH = 3;
